
  // Map country codes to country names
export const countryNameMapping = {
    PE: 'PERU',
    MX: 'MEXICO',
    EC: 'ECUADOR',
    EG: 'EGYPT',
    SA: 'SAUDI ARABIA',
    CO: 'COLOMBIA',
    AR:  'ARGENTINA',
    // Add more country codes and names as needed
  };

  // Map country codes to currency information
export const currencyMap = {
    MX: "MXN (Mexican Peso)",
    SA: "SAR (Saudi Riyal)",
    EG: "EGP (Egyptian Pound)",
    PE: "PEN (Peruvian Sol)",
    EC: "USD (US Dollar)",
    CO: "COP (Colombian Peso)",
    AR: "ARS (Argentine Peso)",
  };
